"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecisionFromNowTooltipLabel = exports.getDecisionFromNowLabel = exports.getTimeWaitingLabel = exports.getTimeToDecisionLabel = exports.getNewLabel = exports.getDeferredStatusLabel = exports.getReviewableStatusLabel = exports.getDecisionStatusLabel = exports.getNoDecisionStatusLabel = void 0;
var _i18n_1 = __importDefault(require("@i18n"));
var duration_1 = require("@utils/date/duration");
var getNoDecisionStatusLabel = function (byWho) {
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.NO_DECISION_TEXT_REACT', {
        BY_WHO: byWho,
    });
};
exports.getNoDecisionStatusLabel = getNoDecisionStatusLabel;
var getDecisionStatusLabel = function (status, domain, byWho, refusalReason) {
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.DECISION_MADE_BY_WHOM.text', {
        DECISION_MADE: status,
        DOMAIN: domain,
        BY_WHO: byWho,
        REFUSAL_REASON: refusalReason ? " (".concat(refusalReason, ")") : '',
    });
};
exports.getDecisionStatusLabel = getDecisionStatusLabel;
var getReviewableStatusLabel = function (queue) {
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.REVIEWABLE_TEXT_REACT', { QUEUE: queue ? " ".concat(queue) : '' });
};
exports.getReviewableStatusLabel = getReviewableStatusLabel;
var getDeferredStatusLabel = function (oldQueue, newQueue, byWho) {
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.DEFERRED_TEXT_REACT', {
        OLD_QUEUE: oldQueue,
        NEW_QUEUE: newQueue,
        BY_WHO: byWho,
    });
};
exports.getDeferredStatusLabel = getDeferredStatusLabel;
var getNewLabel = function () {
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.PROCESSING_TEXT');
};
exports.getNewLabel = getNewLabel;
var getTimeToDecisionLabel = function (isPostReviewed, showClientResult, timeEntered, timeDecisionMade) {
    if (isPostReviewed || showClientResult) {
        return '';
    }
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.TIME_TO_DECISION_REACT', {
        TIME: (0, duration_1.getDurationText)(timeEntered, timeDecisionMade),
    });
};
exports.getTimeToDecisionLabel = getTimeToDecisionLabel;
var getTimeWaitingLabel = function (status, timeSinceEntered) {
    if (status === 'reviewable' || status === 'deferred') {
        return _i18n_1.default.t('ITEM.DECISION_SUMMARY.TIME_WAITING_REACT.TIME_WAITING', { TIME: timeSinceEntered });
    }
    if (status === 'new') {
        return _i18n_1.default.t('ITEM.DECISION_SUMMARY.TIME_WAITING_REACT.TIME_SINCE_ENTERED', { TIME: timeSinceEntered });
    }
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.TIME_WAITING_REACT.OTHER', { TIME: timeSinceEntered });
};
exports.getTimeWaitingLabel = getTimeWaitingLabel;
var getDecisionFromNowLabel = function (timeNum, timeUnit) {
    if (timeNum === 0) {
        return _i18n_1.default.t('ITEM.DECISION_SUMMARY.DECISION_FROM_NOW_REACT.JUST_NOW');
    }
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.DECISION_FROM_NOW_REACT.TEXT', { count: timeNum, TIME_UNIT: timeUnit });
};
exports.getDecisionFromNowLabel = getDecisionFromNowLabel;
var getDecisionFromNowTooltipLabel = function (timestamp, timezone) {
    return _i18n_1.default.t('ITEM.DECISION_SUMMARY.TIMESTAMP_TOOLTIP_REACT', { TIMESTAMP: timestamp, TIMEZONE: timezone });
};
exports.getDecisionFromNowTooltipLabel = getDecisionFromNowTooltipLabel;
